import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const INVITE_ACCOUNT_MUTATION = gql`
  mutation inviteAccount(
    $accountInvitationInput: AccountInvitationInput!
  ) {
    inviteAccount( data: $accountInvitationInput) { status }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class InviteAccountMutation extends Mutation<RootMutation> {
  document = INVITE_ACCOUNT_MUTATION;
}
